import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortComponent } from './sort.component';
import { WmCheckboxModule } from '../checkbox/index';
import { FormsModule } from '@angular/forms';

@NgModule({
	declarations: [SortComponent],
	imports: [CommonModule, WmCheckboxModule, FormsModule],
	exports: [SortComponent]
})
export class WmSortModule {}
